import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import { parseInboxSearch } from '../../inbox/inbox-model.js';
import { InboxPage } from '../../inbox/inbox-page.js';

/** `/inbox` (1.N-1 deliverable 1): the one triage surface, guarded like every authenticated route. */
export const Route = createFileRoute('/inbox/')({
  staticData: { crumb: 'Inbox' },
  validateSearch: (raw: Record<string, unknown>) => parseInboxSearch(raw),
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: InboxRoute,
});

function InboxRoute(): React.JSX.Element {
  const { me } = Route.useRouteContext();
  return <InboxPage me={me} />;
}
